import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  ORDERS_PAGE_BLOCK_DATA_SOURCE,
  OrdersPageBlockDataSource,
} from './orders-page-block-view-model';
import { OrdersPageBlockPreviewDataSource } from './orders-page-block-preview-data-source';
import { OrdersPageBlockStoreDataSource } from './orders-page-block-store-data-source';

export function provideOrdersPageBlockDataSource(): Provider[] {
  return [
    OrdersPageBlockStoreDataSource,
    OrdersPageBlockPreviewDataSource,
    {
      provide: ORDERS_PAGE_BLOCK_DATA_SOURCE,
      useFactory: (): OrdersPageBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(OrdersPageBlockPreviewDataSource)
          : inject(OrdersPageBlockStoreDataSource);
      },
    },
  ];
}
